import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ItsmService } from 'src/app/shared/services/itsm.service';
import { UserPreferenceService } from 'src/app/shared/services/userpreferences.service';

@Component({
  selector: 'app-supportcontactsadd',
  templateUrl: './supportcontactsadd.component.html',
  styleUrls: ['./supportcontactsadd.component.scss']
})
export class SupportcontactsaddComponent implements OnInit {
  email: string = ""
  firstName: string = ""
  lastName: string = ""
  editPage: boolean = false
  editContact:any = {}
  contactId:string = ""

  contactAdded:boolean = false
  contactNotAdd:boolean = false

  contactUpdated:boolean = false
  contactNotUpdated:boolean = false

  loader:boolean=false

  constructor(private userprefService: UserPreferenceService, private itsmService: ItsmService, private router: Router) { 
    if(this.router.getCurrentNavigation().extras.state){
      this.editContact=this.router.getCurrentNavigation().extras.state.userData;
      this.editPage=true;
       
      this.email = this.editContact.email
      this.firstName = this.editContact.firstName
      this.lastName = this.editContact.lastName
      this.contactId = this.editContact.id
    }
  }
  
  ngOnInit(): void {
  }
  submit(){
    this.loader=true;
    if(this.editPage){
      this.itsmService.editContact({
        first_name: this.firstName,
        last_name: this.lastName,
        email: this.email,
        sys_id: this.contactId
      })
      .then(res => {
        sessionStorage.removeItem("itsmContacts")
        this.contactUpdated = true
        this.contactNotUpdated = false

        this.loader=false;

      })
      .catch(ex =>{
        this.loader=false;
        this.contactUpdated = false
        this.contactNotUpdated = true
        console.log("err from eidting contact", ex)
      })
    }
    else{
      this.itsmService.addContact({
        first_name: this.firstName,
        last_name: this.lastName,
        email: this.email
      })
      .then(res => {
        this.loader=false;
        this.contactAdded = true
        this.contactNotAdd = false
        sessionStorage.removeItem("itsmContacts")
      })
      .catch(ex=>{
        this.loader=false;
        console.log("contact not added", ex)
        this.contactAdded = false
        this.contactNotAdd = true
      })
    }
    
  }
}
